import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import PartystatusEditForm from './PartystatusEditForm';
import PartystatusList from './PartystatusList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import PartystatusListView from './PartystatusListView'


export default function PartystatusDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.pharmaslice.partystatusDashboard);
  const [ partystatusId, setPartystatusId] = React.useState('');
  const [reloadPartystatusList, setReloadPartystatusList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <PartystatusEditForm 
            setReloadPartystatusList={setReloadPartystatusList}
            partystatusId={partystatusId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <PartystatusListView 
                      setPartystatusId = {setPartystatusId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
